<template>
  <div class="Invoice">
    <div class="page-title">{{ $t("title.sale_invoice") }}</div>

    <div class="flex">
      <div class="lt-area flex-auto">
        <el-input
          class="input-with-select"
          size="mini"
          v-model="searchWord"
          :placeholder="searchPlaceHolder"
          clearable
          style="width: 300px; "
          @keydown.enter.native="handleClickFilter"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleClickFilter" />
        </el-input>

        <div class="right-search-head" style="display: inline-block; margin-left: 10px">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              :value="search_period" 
              hide-select
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row-splitter">
      <ATable
        ref="table_transaction"
        v-loading="loading_transaction"
        :data="filterDataTransaction"
        max-height="322px"
        highlight-current-row
        hide-top-panel
        hide-button-insert
        hide-pagination
        border
        @current-change="currentChange"
      >
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexTransaction"
          :width="$width.indexw"
        />
        <el-table-column
          prop="name"
          label="거래처"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="location"
          label="사업장"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="uncollected_price"
          label="미수금 합"
          class-name="cell-number"
          width="120"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="published_price"
          label="계산서 발행"
          class-name="cell-number"
          width="120"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="unpublished_price"
          label="계산서 미발행"
          class-name="cell-number"
          width="120"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="credit_line"
          label="여신한도"
          class-name="cell-number"
          width="120"
          :formatter="util.numberFormat"
        />
        <el-table-column
          label="상태"
          width="120"
          :formatter="resolveStatusTransaction"
        />
      </ATable>
    </div>
    
    <div class="row-splitter">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input placeholder="거래처" v-model="customer.name" readonly>
            <template slot="prepend">거래처</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="사업장" v-model="customer.location" readonly>
            <template slot="prepend">사업장</template>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="미발행" :value="customer.unpublished_price | number" readonly>
            <template slot="prepend">미발행</template>
          </el-input>
        </el-col>
      </el-row>
    </div>

    <div class="row-splitter">
      <div class="list-title">
        <h3>세금 계산서 발행 여부 체크 리스트</h3>
      </div>
      <ATable
        ref="table_contract"
        v-loading="loading_invoice"
        max-height="300px"
        :data="tableDataInvoice"        
        hide-top-panel
        hide-button-insert
        hide-pagination
        border
        @row-click="handleInvoiceRowClick"
        @selection-change="selectionChangeInvoice"
      >
        <el-table-column 
          type="selection" 
          align="center" 
          :width="$width.selection" 
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexInvoice"
          :width="$width.index"
        />
        <el-table-column
          prop="issue_date"
          label="계산서 발행일"
          width="105"
          :formatter="util.dateFormat"
        />
        <el-table-column
          label="발행 여부"
          :formatter="resolveStatusInvoice"
          width="160"
        />
        <el-table-column
          prop="price"
          label="계산서 발행 금액"
          class-name="cell-number"
          width="160"
          :formatter="util.numberFormat"
        />
        <el-table-column
          label="상태"
          width="120"
          :formatter="resolveStatusInvoice"
        />
        <el-table-column
          prop="created_user_name"
          label="등록자"
          :width="$width.username"
        />
        <el-table-column
          prop="approval_number"
          label="계산서 발행 번호"
        />
      </ATable>
    </div>

    <div class="flex row-splitter">
      <div class="lb-left flex-fixed">
        <div class="inline">
          <el-button 
            type="primary" 
            :disabled="!has_grant_write"
            @click="handleClickCreate"
          >계산서 등록</el-button>
          <el-button
            type="danger"
            :disabled="selection_invoice.length < 1 || !has_grant_write"
            @click="handleClickCancel"
          >계산서 취소</el-button>
          <el-button
            type="primary"
            :disabled="selection_invoice.length < 1"
            @click="handleClickPreview"
          >세금계산서 미리보기</el-button>
        </div>
      </div>
      <div class="flex-auto align-center"></div>
      <div class="lb-right flex-fixed"></div>
    </div>

    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="세금 계산서"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroy-on-close
      @opened="handleOpened"
    >
      <InvoiceForm
        ref="form"
        v-if="dialogVisible" 
        :customer="customer" 
        :data="form_data" 
        @completed="handleCompleted" 
      />
    </el-dialog>

    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="세금 계산서 미리보기"
      width="900px"
      :visible.sync="dialogVisiblePrint"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <InvoicePrintForm ref="invoice_print" :data="customer" :details="selection_invoice" />
    </el-dialog>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import InvoiceForm from "./InvoiceForm";
import InvoicePrintForm from "./InvoicePrintForm";

export default {
  name: "Invoice",
  mixins: [form_container, authority_level],
  components: { InvoicePrintForm, InvoiceForm },
  data() {
    return {
      title: this.$t('title.invoice'),
      period: {},
      search_period: {value: '0d'},
      searchPlaceHolder: "거래처, 사업장, 발행일",

      search_fieldTransaction: ["name", "location"],
      search_fieldInvoice: ["customer_name", "location"],
      searchWord: null,
      fixedSearchWord: "",

      pageSize: 10,

      currentPageTransaction: 1,
      currentPageInvoice: 1,

      loading_transaction: false,
      items_transaction: [],

      customer: {
        id: 0,
        name: "거래처",
        /*customer_id: 0,
                    customer_name: '거래처',*/
        location: "사업장",
        // price: 10000,
        unpublished_price: null
      },

      loading_invoice: false,
      items_invoice: [],
      selection_invoice: [],

      dialogVisible: false,
      form_data: undefined,

      dialogVisiblePrint: false,
    };
  },
  computed: {
    /* 수금방법 */
    collect_way_flag_options: function() {
      return this.system.options.collect_way_flag;
    },

    /* 거래명세서 */
    filterDataTransaction: function() {
      return this.util.filterMultiFields(
        this.items_transaction,
        this.search_fieldTransaction,
        this.fixedSearchWord
      );
    },
    recordCountTransaction() {
      return this.filterDataTransaction.length;
    },
    tableDataTransaction() {
      return this.filterDataTransaction.slice(
        (this.currentPageTransaction - 1) * this.pageSize,
        this.pageSize * this.currentPageTransaction
      );
    },

    /* 세금계산서 */
    filterDataInvoice: function() {
      return this.items_invoice;
    },
    recordCountInvoice() {
      return this.filterDataInvoice.length;
    },
    tableDataInvoice() {
      return this.filterDataInvoice;
    },
    has_grant_write() {
      return this.isWriteLevel('sale_invoice');
    },
  },
  mounted() {
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.currentPageTransaction = 1;
      this.currentPageInvoice = 1;
      this.loadData();
    },
    handleClickFilter() {
      this.currentPageTransaction = 1;
      this.currentPageInvoice = 1;
      this.fixedSearchWord = this.searchWord;
      this.selectFirstTransaction();
    },

    selectFirstTransaction(id) {
      this.$nextTick(() => {
        let table = this.$refs.table_transaction;
        let data = table.data;
        if (data) {
          let row = data.find(item => item.id === id);
          setTimeout(() => {
            table.setCurrentRow(id ? row : data[0]);
          }, 100);
        }
      });
    },

    loadData(id) {
      this.loading_transaction = true;
      this.api.listInvoice(this.period).then(res => {
        this.loading_transaction = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.title, res.message);
          return;
        }
        this.items_transaction = res.data;
        this.selectFirstTransaction(id);
      });
    },

    currentChange(currentRow /*, oldCurrentRow*/) {
      this.customer = currentRow ? currentRow[0] : {};
      this.loadInvoice();
    },

    handleCurrentChangeTransaction(value) {
      this.currentPageTransaction = value;
      this.selectFirstTransaction();
    },

    loadInvoice() {
      let customer_id = this.customer.id;
      if (!customer_id) {
        this.items_invoice = [];
        return;
      }
      this.loading_invoice = true;
      this.api.listInvoiceByCustomer(customer_id, this.period).then(res => {
        this.loading_invoice = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.title, res.message);
          return;
        }

        this.items_invoice = res.data;
      });
    },

    selectionChangeInvoice(selection) {
      this.selection_invoice = selection;
    },

    handleIndexTransaction(index) {
      return (
        this.recordCountTransaction -
        (this.currentPageTransaction - 1) * this.pageSize -
        index
      );
    },
    handleIndexInvoice(index) {
      return (
        this.recordCountInvoice -
        (this.currentPageInvoice - 1) * this.pageSize -
        index
      );
    },
    resolveStatusTransaction(row) {
      if (!row["credit_line"]) {
        return "진행";
      }
      return row["uncollected_price"] > row["credit_line"]
        ? "거래중지"
        : "진행";
    },
    resolveStatusInvoice(row) {
      return row["approval_number"] && row["approval_number"] !== ""
        ? "발행"
        : "미발행";
    },
    resolveCollectWay(row, cell, cellValue) {
      let collect_way = this.collect_way_flag_options.find(item => {
        return item.value === cellValue;
      });
      return collect_way ? collect_way.label : null;
    },

    handleClickCreate() {
      this.openDialog();
    },

    handleInvoiceRowClick(row) {
      this.openDialog(row);
    },

    handleClickCancel() {
      if (this.selection_invoice.length < 1) {
        this.util.notify(
          this,
          "w",
          this.$t("title.invoice"),
          this.$t("message.no_selection")
        );
        return;
      }

      /** 취소 */
      return this.$confirm("취소하시겠습니까?", this.title, {
        type: "warning",
        confirmButtonText: "네",
        cancelButtonText: "아니오"
      })
        .then(() => {
          this.doDelete();
        })
        .catch(() => {});
    },
    doDelete() {
      let params = this.selection_invoice.map(item => item.id);
      this.api.cancelInvoice(params).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_error(
            this,
            this.$t("title.invoice"),
            res.message
          );
          return;
        }

        let id = this.customer.id;
        this.loadData(id);

        this.currentPageInvoice = 1;
        // this.loadInvoice();
      });
    },
    handleClickPreview() {
      this.dialogVisiblePrint = true;
    },

    /** 다이얼로그 팝업 */
    openDialog(data) {
      this.form_data = data ? Object.assign({}, data) : undefined;
      if (this.form_data) {
        this.form_data.price_old = this.form_data.price;
      }
      this.dialogVisible = true;
    },

    handleCompleted(action, message) {
      this.dialogVisible = false;

      let id = this.customer.id;
      switch (action) {
        case "create":
        case "delete":
          this.loadData(id);

          // this.loadData();

          this.currentPageInvoice = 1;
          // this.loadInvoice();
          break;
        case "update":
          this.loadInvoice();
          break;
      }

      if (!message) {
        return;
      }
      this.$notify(message);
    },
    handleCompletedPrint() {
      this.dialogVisiblePrint = false;
    }
  }
};
</script>
